module.exports = __webpack_public_path__ + "img/Tratamento_de_Feridas_e_Curativos.6cfd4ae8.jpg";